document.addEventListener("DOMContentLoaded", () => {
  try {
    import ("../../common/index");
    import ("../../common/search/search-validation-mobile");
    import ("../../common/search/search-validation-desktop");
    import ("../../common/sidebar/mobile-sidebar");
    import ("../../common/sidebar/desktop-item");

    console.log("DOMContentLoaded, on tag page");
  } catch (error) {
    console.error("An error occurred while loading the files on tag page", error);
  }
});
